import React from 'react';

import { Heading } from '@eluve/components';

export interface OutputTitleProps {
  title: string;
}

export const OutputTitle: React.FC<OutputTitleProps> = ({ title }) => {
  return (
    <Heading size="3xl" className="underline">
      {title}
    </Heading>
  );
};
